// @ts-nocheck

import * as R from 'ramda';
import { reducerWrapper } from '../../support/utils';

import { ESP_VALIDATE } from '../../actions/EmailOnboarding/ESPValidate';

var INIT_STATE = {
  loading: false,
  error: null,
  // input URL -> https://pinterest.com/explore/dogs
  url: null,
  // method enum for /3-onboarding/validate -> 'url_to_metatag_matching' | 'auto_fetch' | 'branch_link' | 'dl_setup_failed'
  method: null,
  // gating bool to validate that a user is done inputing url
  submitted: false,
  // payload from /3-onboarding/validate
  data: null,
};

function Handler(state, action) {
  switch (action.type) {
    case ESP_VALIDATE.response:
      return R.merge(state, {
        loading: false,
        error: null,
        data: R.merge(state.data, action.data),
      });

    case ESP_VALIDATE.set:
      return R.merge(state, action.new_state);

    case ESP_VALIDATE.reset:
      return R.merge(INIT_STATE, action.new_state);
    default:
      return state;
  }
}

const EspValidate = reducerWrapper(INIT_STATE, Handler, {
  request: [ESP_VALIDATE],
  error: [ESP_VALIDATE],
  resetOn: ['APP_CHANGE'],
});

export default EspValidate;
